<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
                        <div class="container">
                            <div class="titleBox">
                                <div>申请信息：</div>
                                <div class="titleNum">编号：{{invoiceList.approveCode}}</div>
                            </div>
                            <el-form class="dataFormBox" :inline="true" :model="invoiceList">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="项目部：">
                                            <el-select v-model="invoiceList.projectDeptId" placeholder="请选择项目部" disabled>
                                                <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="项目名称：">
                                            <el-input v-model="invoiceList.projectName" placeholder="请输入项目名称" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="欠款单位：">
                                            <el-input v-model="invoiceList.debtName" placeholder="请输入欠款单位" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="项目地点：">
                                            <el-input v-model="invoiceList.projectAddress" :readonly="true" placeholder="请输入项目地点" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="发票抬头：">
                                            <el-input v-model="invoiceList.billHead" placeholder="请输入发票抬头" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="发票金额：">
                                            <el-input v-model="invoiceList.billPrice" :readonly="true" placeholder="请输入发票金额" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item style="width: 100%" label-width="120px" label="发票备注：">
                                            <el-input v-model="invoiceList.remark" show-word-limit
                                                      type="textarea" :rows="2" maxlength="200" :readonly="true"
                                                      placeholder="请输入发票备注" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="titleBox">
                                <div>录入发票信息：</div>
                            </div>
                        </div>
                        <div class="containerBox">
                            <el-form class="dataFormBox" :inline="true" :model="invoiceList">
                                <el-row style="display: flex;align-items: center">
                                    <el-col :span="7">
                                        <el-form-item label-width="100px" label="发票号码：">
                                            <el-input v-model="invoiceList.billNumber" placeholder="请输入发票号码" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="发票金额：">
                                            <el-input v-model="invoiceList.billPrice" placeholder="请输入发票金额" :readonly="true" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label-width="120px" label="发票附件：">
                                            <div class="inputImgBox" v-if="isShowImg">
<!--                                                <img :src="invoiceList.billUrl" alt="">-->
                                                <el-image
                                                        style="width: 75px;height: 45px;"
                                                        :src="invoiceList.billUrl"
                                                        :preview-src-list="[invoiceList.billUrl]">
                                                </el-image>
<!--                                                <div>123456.zip</div>-->
                                            </div>
                                            <div class="inputImgBox blueColor" v-else @click="uploadBill">下载发票附件</div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <div class="container">
                            <div class="titleBox">
                                <div>本次收款信息：</div>
                            </div>
                            <el-form class="dataFormBox" :inline="true" :model="dataForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="收款金额：">
                                            <el-input v-model="dataForm.receiptsPrice" placeholder="请输入发票金额" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label-width="120px" label="收款备注：">
                                            <el-input v-model="dataForm.receiptsRemark" show-word-limit
                                                      type="textarea" :rows="4" maxlength="100" style="width: 284px;"
                                                      placeholder="请输入发票备注" clearable></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="titleBox">
                                <div>关联收款信息：</div>
                            </div>
                        </div>
                        <div class="containerBox">
                            <el-row>
                                <el-col :span="24">
                                    <div class="operatePanel">
                                        <el-button
                                                @click="showAddCollection()"
                                        >新增收款记录</el-button>
                                        <el-button
                                                @click="deleteBtn()"
                                        >删除收款记录</el-button>
                                    </div>
                                </el-col>
                            </el-row>
                            <div ref="main" style="height: 390px">
                                <el-table
                                        ref="dataTable"
                                        :data="accountList"
                                        highlight-current-row
                                        @selection-change="handleSelectionChange"
                                        @row-click="rowClicked"
                                        size="mini"
                                        height="100%"
                                        border
                                >
                                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                                    <el-table-column
                                            label="序号"
                                            type="index"
                                            width="50"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="projectDeptName"
                                            label="项目部"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="projectName"
                                            label="项目名称"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="number"
                                            label="期数"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="contractPrice"
                                            label="合同金额"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="finishPrice"
                                            width="100"
                                            label="完成产值"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="calculatePrice"
                                            width="100"
                                            label="计量金额"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="applyTime"
                                            label="申请日期"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="replyPrice"
                                            label="批复金额"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="replyTime"
                                            label="批复时间"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="outputTaxPrice"
                                            label="销项税金额"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="receiptPrice"
                                            label="收款金额"
                                            :show-overflow-tooltip="true"
                                    ></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="审批流程" name="Tab2">
                      <approveLine
                          :itemId="contractId"
                          :approveType="approveType"
                      ></approveLine>
                    </el-tab-pane>
                </el-tabs>

            </el-main>
            <el-footer class="container">
                <div class="btnMid">
                    <el-button type="info" @click="reset()">取 消</el-button>
                    <el-button type="primary" @click="query()">保 存</el-button>
                </div>
            </el-footer>
        </el-container>

        <add-collection
                :visible="addVisible"
                ref="addCollection"
                @refreshDataList="refreshDataList"
        ></add-collection>
    </div>
</template>

<script>
    import {
        getOutputBillDetailService,
        getDeptListService,
        getInvoiceApproveListService,
        getTempUrlService,
        receiptsService,
    } from '@/services/invoiceServices'

    import AddCollection from "./confirm-addCollection";
    import {exportExcelService2} from "../../../services/allContractServices";
    import approveLine from "@/page/approveComponents/ApproveHistoryLine";

    export default {
        name: "input-confirm",
        data(){
            return {
                dataForm:{
                    receiptsPrice:'',
                    receiptsRemark:'',
                },
                tableForm:{
                    pageIndex: 1,
                    pageSize: 10,
                },
                accountList:[],    //关联信息表格信息
                selectItems:[], //选中的列表

                addVisible: false, //新增收款记录弹窗
                activeName: 'Tab1', //tab栏标识
                approveList: [], // 审批流列表

                contractId: 0, // 审批流列表
                approveType: "OUTPUT_BILL_APPROVE", //审批类型

                approveId:'',  //申请id
                outputBillId:'',    //发票id
                deptList:[],
                isShowImg: false,
                invoiceList:{},    //发票信息
                typeUrl: '', //url类型
            }
        },
        components: {
            approveLine,
            AddCollection
        },
        methods:{
            onActive(menuCode) {
                this.contractId = this.tabRouteParam.approveId;
                this.approveId = this.tabRouteParam.approveId;
                this.outputBillId = this.tabRouteParam.outputBillId;

                this.getDeptList(); // 获取项目部列表
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                        this.getApproveDetail();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /***
             * 获取审批详情列表
             */
            getApproveDetail(){
                let params = {
                    outputBillId: this.outputBillId
                }
                getOutputBillDetailService(params).then( res => {
                    if(res.code == 10000000){
                        this.isShowImg = false;
                        this.invoiceList = res.data;
                        if(res.data.billAttachmentUrl){
                            this.typeUrl = res.data.billAttachmentUrl.split('.')[1];
                            // doc，elsx，zip

                            this.getTempUrl(res.data.billAttachmentUrl);
                        }
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /***
             * 获取图片路径
             */
            getTempUrl(url){
                let params = {
                    filePath: url
                }
                getTempUrlService(params).then( res => {
                    if(res.code == 10000000){
                        this.invoiceList.billUrl = res.data;
                        this.$nextTick(()=>{
                            if((this.typeUrl).toLowerCase() == 'jpeg' ||(this.typeUrl).toLowerCase() == 'jpg' ||
                               (this.typeUrl).toLowerCase() == 'png'|| (this.typeUrl).toLowerCase() == 'gif'){
                                this.isShowImg = true;
                            }else{
                                this.isShowImg = false
                            }
                        })
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            query(){
                let idList = []
                this.accountList.map( item => {
                    idList.push(item.id)
                })
                let params = {
                    ...this.dataForm,
                    receiptsItemIdList: idList,
                    id: this.outputBillId
                }
                receiptsService(params).then( res => {
                    if(res.code == 10000000){
                        this.$message.success('本次收款确认成功');
                        this.reset();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            reset(){
                this.bus.$emit("tabClose", "inputConfirm");
                this.bus.$emit("navMenuChange", {
                    routeId: "inputInvoice"
                });
            },
            uploadBill(){
                if((this.typeUrl).toLowerCase() == 'pdf'){
                    window.open(this.invoiceList.billUrl)
                }else{
                    exportExcelService2(this.invoiceList.billUrl).then(res1 => {
                        this.$message.success('导出成功');
                    });
                }
            },
            //显示新增窗口
            showAddCollection(){
                this.addVisible = true
                this.$nextTick(() => {
                    this.$refs.addCollection.init();
                })
            },
            //刷新数据列表
            refreshDataList(arr){
                if(arr.length == 0){
                    return
                }
                if(this.accountList.length == 0){
                    this.accountList = arr;
                }else{
                    arr.map(arrItem => {
                        let flag = false;
                        this.accountList.map(item =>{
                            if(item.id == arrItem.id){
                                flag = true;
                            }
                        })
                        if(!flag){
                            this.accountList.push(arrItem)
                        }
                    })
                }

            },
            //删除选中的数据
            deleteBtn(){
                if(this.selectItems.length != 0){
                    this.selectItems.map(item =>{
                        this.accountList.splice(this.accountList.indexOf(item),1)
                    })
                }
            },
            // tabbar切换
            handletabClick(tab, event){
                console.log(tab)
            },
            // 列代表多选回调
            handleSelectionChange(val) {
                this.selectItems = val;
            },
            // 点击选中行
            rowClicked(row, event, column) {
                this.$refs.dataTable.toggleRowSelection(row);
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
        }
    }
    /deep/.el-textarea{
        width: 600px;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px 0;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 20px;
        .inputImgBox{
            display: flex;
            img {
                width: 75px;
                height: 45px;
                margin-right: 59px
            }
            div {
                color: rgba(25, 159, 255, 100);
                font-size: 14px;
            }
        }
        .blueColor{
            color: #409EFF;
            cursor:pointer
        }
    }
    .operatePanel{
        margin: 22px 0 17px 100px;
    }
    .btnMid {
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }
    /deep/.el-tabs__item{
        padding: 0 20px !important;
    }
    /deep/.el-input.is-disabled .el-input__inner{
        background-color: #fff !important;
        color: #606266 !important;
    }
</style>
